import { render, staticRenderFns } from "./TagChange.vue?vue&type=template&id=95c9058e&scoped=true&"
import script from "./TagChange.vue?vue&type=script&lang=js&"
export * from "./TagChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c9058e",
  null
  
)

export default component.exports